import { gql } from '@apollo/client';

const SUBSCRIPTION = gql`
  mutation subscription($msisdn: String!) {
    subscription(msisdn: $msisdn){
      cg_url
      mf_id
      msisdn
      error
      
    }
  }
`;

export default SUBSCRIPTION;
